import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth, errorMessage } from '../../context/AuthContext';
import RichEditor from '../../components/RichEditor';

export default function AdminArticleEdit() {
  const { id } = useParams();
  const isNew = !id;
  const { authFetch, uploadImage } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    title: '', excerpt: '', content: '', cover_image: '', tags: '', published: 1
  });
  const [flash, setFlash] = useState(null); // { type: 'ok' | 'error', text }
  const [uploading, setUploading] = useState(false);
  const [saving, setSaving] = useState(false);

  const set = (patch) => setForm(prev => ({ ...prev, ...patch }));

  useEffect(() => {
    if (isNew) return;
    authFetch('/api/articles/admin')
      .then(r => r.ok ? r.json() : Promise.reject(new Error('chargement impossible')))
      .then(list => {
        const a = list.find(x => x.id === Number(id));
        if (a) setForm({ ...a, excerpt: a.excerpt || '', tags: a.tags || '', cover_image: a.cover_image || '', published: !!a.published });
        else setFlash({ type: 'error', text: 'Article introuvable' });
      })
      .catch(e => setFlash({ type: 'error', text: `Erreur : ${e.message}` }));
    // eslint-disable-next-line
  }, [id]);

  const upload = async (e) => {
    const f = e.target.files[0]; if (!f) return;
    setUploading(true); setFlash(null);
    try {
      const url = await uploadImage(f);
      set({ cover_image: url });
    } catch (err) {
      setFlash({ type: 'error', text: `Image non ajoutée : ${err.message}` });
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  const save = async (e) => {
    e.preventDefault();
    setSaving(true); setFlash(null);
    try {
      const r = await authFetch(
        isNew ? '/api/articles' : `/api/articles/${id}`,
        { method: isNew ? 'POST' : 'PUT', body: JSON.stringify(form) }
      );
      if (!r.ok) throw new Error(await errorMessage(r));
      if (isNew) return navigate('/admin/articles');
      setFlash({ type: 'ok', text: '✓ enregistré' });
      setTimeout(() => setFlash(null), 2000);
    } catch (err) {
      setFlash({ type: 'error', text: `Non enregistré : ${err.message}` });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <h1 style={{ fontStyle: 'italic', marginBottom: '1.5rem' }}>
        {isNew ? 'Nouvel article' : 'Éditer l\'article'}
      </h1>
      {flash && <div className={`flash ${flash.type === 'error' ? 'error' : ''}`}>{flash.text}</div>}
      <form onSubmit={save}>
        <div className="form-group">
          <label>Titre</label>
          <input value={form.title} onChange={e => set({ title: e.target.value })} required />
        </div>
        <div className="form-group">
          <label>Extrait (courte description)</label>
          <input value={form.excerpt} onChange={e => set({ excerpt: e.target.value })} />
        </div>
        <div className="form-group">
          <label>Image de couverture {uploading && '— envoi…'}</label>
          <input type="file" accept="image/jpeg,image/png,image/gif,image/webp" onChange={upload} disabled={uploading} />
          {form.cover_image && (
            <div style={{ marginTop: 10 }}>
              <img src={form.cover_image} alt="" style={{ maxWidth: 300, border: '1.5px solid var(--ink)' }} />
              <button type="button" className="btn secondary" style={{ display: 'block', marginTop: 8 }}
                onClick={() => set({ cover_image: '' })}>retirer l'image</button>
            </div>
          )}
        </div>
        <div className="form-group">
          <label>Tags (séparés par virgules)</label>
          <input value={form.tags} onChange={e => set({ tags: e.target.value })} placeholder="dev, life, voyage" />
        </div>
        <div className="form-group">
          <label>Contenu</label>
          <RichEditor value={form.content} onChange={v => set({ content: v })} />
        </div>
        <div className="form-group">
          <label>
            <input type="checkbox" checked={!!form.published}
              onChange={e => set({ published: e.target.checked ? 1 : 0 })} /> Publié
          </label>
        </div>
        <button className="btn" type="submit" disabled={saving || uploading}>
          {saving ? 'enregistrement…' : 'enregistrer'}
        </button>
        <button className="btn secondary" type="button" style={{ marginLeft: '.5rem' }} onClick={() => navigate('/admin/articles')}>annuler</button>
      </form>
    </div>
  );
}
